import { ChevronDownIcon } from "@heroicons/react/solid";
import { Button, Menu } from "ui";

type Options = Array<[string, string]>;

type Props = {
  options: Options;
  onSelect: (option: [string, string]) => void;
};

export default function ExportDropdown({ options, onSelect }: Props) {
  return (
    <Menu>
      <Menu.Trigger render={<Button className="space-x-2 p-2" />}>
        <span>Export</span>
        <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
      </Menu.Trigger>

      <Menu.Popup className="py-1">
        {options.map((option, index) => (
          <Menu.Item key={option[0] + index} onClick={() => onSelect(option)}>
            {option[1]}
          </Menu.Item>
        ))}
      </Menu.Popup>
    </Menu>
  );
}
